import { assertResponseError } from './assert';
import { preparePopularRegions } from '../../mappers/popularRegions';
import {
  fetchGetPopularCitiesForGeopopup,
  TGetPopularCitiesForGeopopupResponse,
} from '../../repositories/geo-suggest/v1/get-popular-cities-for-geopopup';
import { IApplicationContext } from '../../types/applicationContext';
import { IRegion } from '../../types/requestForm';

export const getPopularRegions = async (context: IApplicationContext): Promise<IRegion[]> => {
  const { httpApi, logger } = context;

  try {
    const response: TGetPopularCitiesForGeopopupResponse = await fetchGetPopularCitiesForGeopopup({
      httpApi,
    });

    assertResponseError(response);

    return preparePopularRegions(response.response);
  } catch (error) {
    logger.error(error, {
      comment: '[Degradation] Используется пустой список популярных регионов',
    });

    return [];
  }
};
